var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex"},[_c('div',{staticClass:"w-2/12"},[_c('Sidebar')],1),_c('div',{staticClass:"flex-grow"},[_c('TaskView',{attrs:{"day":_vm.$route.name}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }